// Application Configuration
export const CONFIG = {
  // Google Apps Script Web App URL - UPDATE THIS AFTER DEPLOYMENT
  APPS_SCRIPT_URL:
    "https://script.google.com/macros/s/AKfycbzlLuc4pi2-gb9lgy5FR8uhaltAvxD687uGxGEYidk8wmReLErNbN7nKJ99k3BjrGEq/exec",

  // Company Information
  COMPANY_NAME: "ບໍລິສັດ ທິບພະລັງສີ ກໍ່ສ້າງຄົບວົງຈອນ ຈຳກັດຜູ້ດຽວ",

  // API Endpoints
  API: {
    GET_DASHBOARD: "getDashboard",
    GET_METADATA: "getMetadata",
  },

  // Default Settings
  DEFAULT_CURRENCY: "₭",
  BASE_CURRENCY: "₭",

  // Date Formats
  DATE_FORMAT: {
    LOCALE: "lo-LA",
    OPTIONS: { year: "numeric", month: "long", day: "numeric" },
  },

  // Chart Colors
  CHART_COLORS: {
    income: "#10b981",
    expense: "#ef4444",
    balance: "#3b82f6",
    categories: [
      "#10b981",
      "#3b82f6",
      "#f59e0b",
      "#8b5cf6",
      "#ec4899",
      "#14b8a6",
      "#f97316",
      "#06b6d4",
    ],
  },

  // Lao Month Names
  LAO_MONTHS: [
    "ມັງກອນ",
    "ກຸມພາ",
    "ມີນາ",
    "ເມສາ",
    "ພຶດສະພາ",
    "ມິຖຸນາ",
    "ກໍລະກົດ",
    "ສີງຫາ",
    "ກັນຍາ",
    "ຕຸລາ",
    "ພະຈິກ",
    "ທັນວາ",
  ],
};
